import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const saleRateIndexingRuleSuccess = (state, saleRateIndexingRuleList) => {
  state.saleRateIndexingRuleList = saleRateIndexingRuleList;
};

const createSaleRateIndexingRuleSuccess = (state, rule) => {
  state.saleRateIndexingRuleList.push(rule);
};

const updateSaleRateIndexingRuleSuccess = (state, saleRateIndexingRule) => {
  const index = state.saleRateIndexingRuleList.findIndex((rule) => (rule.guid === saleRateIndexingRule.guid));
  state.saleRateIndexingRuleList.splice(index, 1, saleRateIndexingRule);
};

const removeSaleRateIndexingRuleSuccess = (state, ruleGuid) => {
  state.saleRateIndexingRuleList = state.saleRateIndexingRuleList.filter((rule) => rule.guid !== ruleGuid);
};

const resetData = (state) => {
  state.saleRateIndexingRuleList = [];
};

export const mutations = {
  [MutationTypes.SALE_RATE_INDEXING_RULE_LIST_SUCCESS]: saleRateIndexingRuleSuccess,
  [MutationTypes.CREATE_SALE_RATE_INDEXING_RULE_SUCCESS]: createSaleRateIndexingRuleSuccess,
  [MutationTypes.UPDATE_SALE_RATE_INDEXING_RULE_SUCCESS]: updateSaleRateIndexingRuleSuccess,
  [MutationTypes.REMOVE_SALE_RATE_INDEXING_RULE_SUCCESS]: removeSaleRateIndexingRuleSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
